import React, { useEffect, useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import produt1 from '../../assets/images/products/img02.jpg';
import produt2 from '../../assets/images/products/img03.jpg';
import produt3 from '../../assets/images/products/img04.jpg';
import produt4 from '../../assets/images/products/img05.jpg';
import produt5 from '../../assets/images/products/img06.jpg';
import * as AuthVerify from '../../lib/common';
import Zoom from 'react-img-zoom';

import './ProductDetailImage.styles.css';

const product = { produt1, produt2, produt3, produt4, produt5 };

const options = {
  margin: 5,
  responsiveclass: true,
  nav: true,
  dots: false,
  loop: false,
  navText: ["<span></span>", "<span></span>"],
  responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    600: {
      items: 2,
    },
    700: {
      items: 3,
    },
    1000: {
      items: 3,

    }
  },
};

const labelOptions = {
  autoWidth: true,
  margin: 0,
  responsiveclass: true,
  nav: true,
  dots: false,
  loop: false,
  navText: ["<span></span>", "<span></span>"],
  responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    600: {
      items: 2,
    },
    700: {
      items: 3,
    },
    1000: {
      items: 3,

    }
  },
};


const ProductDetailImage = ({imageurl,baseUrl,productName,productDetails}) => {
  const [selected, setSelected] = useState(product.produt1);
  const [imageurls, setImageurls] = useState(false);
  const [images, setImages] = useState(false);
  const [labels, setLabels] = useState(false);

  useEffect(async () => {
    setImages(productDetails.images);
    setLabels(productDetails.labels)
    var mainImage =imageurl;
    productDetails.images.forEach(element => {
      if(element.mainimage)mainImage=element.imageulr;
    });
    setImageurls(mainImage);
  }, [imageurl])

  const CustomZoom =({url}) => {
    return <Zoom
      img={AuthVerify.getImageLink(url)}
      zoomScale={1}
      height={257}
    />
  }

  const CustomOwlCarousel =() => {
    return <OwlCarousel className="product-flexslider hidden-buttons owl-theme" {...options}>
      {/* <div className="more-views-items" onClick={() => setImageurls(imageurls)}> <img id="product-zoom" src={baseUrl+imageurls} alt={productName} /> </div> */}
      {images && images.map((image,i) =>{
        return <div key={i} className="more-views-items" onClick={() => setImageurls(AuthVerify.getImageLink(image.imageulr))}> <img id="product-zoom" src={AuthVerify.getImageLink(image.imageulr)} alt={productName} /> </div>
      })}
    </OwlCarousel>
  }

  const CustomLabels =() => {
    return <OwlCarousel className="product-flexslider hidden-buttons owl-theme" {...labelOptions}>
      {labels && labels.map((image,i) =>{
        return <div key={i} className="more-views-items" style={{ height: "50px", width: "50px" }} onClick={() => setImageurls(AuthVerify.getImageLink(image.imageurl))}> <img id="product-zoom" src={AuthVerify.getImageLink(image.imageurl)} alt={image.labelname} /> </div>
      })}
    </OwlCarousel>
  }

  return (
    <div className="product-image">
      {imageurls && <>
        <div className="product-full">
          <CustomZoom url={imageurls}/>
        </div>
        <div className="more-views">
          <div className="slider-items-products">
              <div id="gallery_01" className="product-flexslider hidden-buttons ">
                <div className="slider-items slider-width-col4 block-content">
                  <CustomOwlCarousel/>
                </div>
              </div>
          </div>
        </div>
        <div className="more-views">
          <div className="slider-items-products">
              <div id="gallery_02" className="product-flexslider hidden-buttons ">
                <div className="slider-items slider-width-col4 block-content">
                  <CustomLabels/>
                </div>
              </div>
          </div>
        </div>
        </>
      }
    </div>
  );
};

export default ProductDetailImage;
